module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-noicon-78368de4a343293dbfc00605dbb195c8.png";